// Rules for a Sentinel's cap in a brand, typed on the Users page or as the brand's cap in settings.

export const MAX_ACTIVE_TICKETS_CEILING = 100;

/** The brand's cap for every Sentinel when it has none set (Sentinel workspace settings). */
export const DEFAULT_MAX_ACTIVE_TICKETS = 10;

/** A cap typed on the Users page or the settings page: a whole number 1 to 100, or empty to inherit. */
export function capIsValid(cap: number | null): boolean {
	return cap === null || (Number.isInteger(cap) && cap >= 1 && cap <= MAX_ACTIVE_TICKETS_CEILING);
}
